module.exports = __webpack_public_path__ + "static/media/preloader.5a6e5302.svg";